<template>
  <div>
    <el-form :model="menuObj" :ref="`tform-0`" label-width="0">
      <draggable
        :group="{ name: 'drag', disabled: '.disabled' }"
        class="dragArea"
        tag="div"
        v-bind="dragOptions"
        :list="menuList"
        :component-data="getComponentData()"
      >
        <template v-for="(el, index) in menuObj.menuList">
          <div
            class="dragger-box drag-item disabled"
            v-if="el.id && el.merchantId === 0 && el.status === 1"
            :key="index"
          >
            <el-form-item
              :prop="`menuList.${index}.name`"
              :rules="[{ required: true, message: $t('storage::out-stock::input_name'), trigger: 'change' }]"
            >
              <el-input
                :value="$t(`system::${type == 6 ? 'inStock' : 'outStock'}::type::${el.name}`)"
                class="input-item"
                :disabled="el.id && el.merchantId === 0"
              ></el-input>
              <!-- <i class="iconfont iconclose-circle icon" title="删除" v-if="el.id && el.merchantId > 0"></i>
              <i class="iconfont iconSort drag-icon icon" title="移动" v-if="el.id && el.merchantId > 0"></i> -->
            </el-form-item>
          </div>
        </template>
        <template v-for="(el, index) in menuObj.menuList">
          <div class="dragger-box drag-item" :key="index" v-if="(!el.id || el.merchantId > 0) && el.status === 1">
            <el-form-item
              :prop="`menuList.${index}.name`"
              :rules="[{ required: true, message: $t('storage::out-stock::input_name'), trigger: 'change' }]"
            >
              <el-input
                v-model.trim="el.name"
                class="input-item"
                :disabled="el.id && el.merchantId == 0"
                maxlength="20"
                :placeholder="$t('storage::out-stock::input_holder')"
              ></el-input>
              <i
                class="iconfont iconclose-circle icon"
                @click="onDel(index)"
                :title="$t('storage::out-stock::delete')"
                v-if="!el.id || el.merchantId > 0"
              ></i>
              <i
                class="iconfont iconSort drag-icon icon"
                :title="$t('storage::out-stock::move')"
                v-if="!el.id || el.merchantId > 0"
              ></i>
            </el-form-item>
          </div>
        </template>
      </draggable>
      <el-form-item style="margin-top: 20px;">
        <el-button @click="addItem" icon="el-icon-plus">
          {{ buttonName }}
        </el-button>
        <el-button @click="saveItem" :loading="loading" type="primary">
          {{ $t('storage::out-stock::save') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'Draggers',
  components: {
    draggable
  },
  props: {
    type: {
      default: null
    },
    menuList: {
      default: () => []
    },
    buttonName: {
      default: '添加分类'
    },
    loading: {
      default: false
    }
  },
  computed: {
    menuObj() {
      return {
        menuList: this.menuList
      }
    },
    dragOptions() {
      return {
        group: 'drag',
        handle: '.drag-icon',
        dragClass: 'drag-item',
        chosenClass: 'chosenClass',
        forceFallback: true,
        ghostClass: 'ghost',
        animation: 0,
        fallbackOnBody: true,
        swapThreshold: 0.65
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
    console.log(this.menuList)
  },
  methods: {
    onStart(el) {
      console.log(el)
    },
    onMove(el) {
      // console.log(el, this.menuList, this.parentItem)
      console.log(el)
      console.log(this.menuList)
    },
    onAdd(el) {
      console.log(el)
    },
    saveItem(el) {
      this.$refs['tform-0'].validate(valid => {
        if (valid) {
          this.$emit('save', this.menuList)
        }
      })
    },
    onSort(el) {
      // 处理排序 select组件updated 失效
      console.log(this.menuList)
    },
    onDel(index) {
      if (this.menuList[index].id) {
        this.menuList.splice(index, 1, {
          ...this.menuList[index],
          status: 0
        })
      } else {
        this.menuList.splice(index, 1)
      }
    },
    addItem() {
      console.log('item')
      const length = this.menuList.length
      this.menuList.push({
        name: '',
        sequence: length,
        type: this.type,
        status: 1
      })
    },
    getComponentData() {
      return {
        on: {
          start: this.onStart,
          move: this.onMove,
          add: this.onAdd,
          sort: this.onSort
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.drag-item {
  padding: 0px;
  width: 320px;
  display: inline-block;
  .input-item {
    width: 250px;
  }
  .icon {
    cursor: pointer;
    margin-left: 6px;
  }
  .iconSort {
    cursor: move;
    margin-left: 5px;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
}

.chosenClass {
  .iconclose-circle {
    visibility: hidden;
  }
}

.ghost {
  .iconclose-circle {
    visibility: inherit;
  }
}
</style>
